import { render, staticRenderFns } from "./MapBackgroundGeneratorTool.vue?vue&type=template&id=674554b2&scoped=true"
import script from "./MapBackgroundGeneratorTool.vue?vue&type=script&lang=js"
export * from "./MapBackgroundGeneratorTool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674554b2",
  null
  
)

export default component.exports